import { render, staticRenderFns } from "./ServiceBranch.vue?vue&type=template&id=08032c82&scoped=true"
import script from "./ServiceBranch.vue?vue&type=script&lang=js"
export * from "./ServiceBranch.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ServiceBranch.vue?vue&type=style&index=1&id=08032c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08032c82",
  null
  
)

export default component.exports